import type { PlanFinding } from '@/lib/apiTypes'

/** Findings whose category/meta marks them as drift. */
export function driftFindings(findings: PlanFinding[]): PlanFinding[] {
  return findings.filter((f) => f.category === 'drift' || f.meta?.kind === 'drift')
}

/** Findings flagged as touching stateful resources (M3 meta). */
export function statefulCount(findings: PlanFinding[]): number {
  return findings.filter((f) => f.meta?.stateful === true).length
}

/** address -> plan replacement cause, from redacted replacement findings (M3). */
export function replacementCauseMap(findings: PlanFinding[]): Record<string, string> {
  const out: Record<string, string> = {}
  for (const f of findings) {
    const meta = f.meta ?? {}
    const cause =
      (typeof meta.replacement_cause === 'string' && meta.replacement_cause) ||
      (typeof meta.forces_replacement === 'string' && meta.forces_replacement) || null
    const isReplace = cause != null || f.category === 'replacement' || (f.rule_id?.toLowerCase().includes('replace') ?? false)
    if (isReplace && f.resource) out[f.resource] = cause || f.description || f.title
  }
  return out
}

export function redactedCell(value: unknown): string {
  if (value == null) return '•••'
  if (typeof value === 'string') return value
  return '•••'
}

